module.exports = __webpack_public_path__ + "static/media/morocco.f1bfecaa.png";